import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { AuthGuard } from '@/components/eg/auth-guard';
import { EGHeader } from '@/components/eg/eg-header';
import { RouteTracker } from '@/components/eg/route-tracker';

export default function HelpLayout() {
  return (
    <AuthGuard>
      <Suspense>
        <RouteTracker />
      </Suspense>
      <EGHeader isAuthed />
      <main className="h-[calc(100vh-82px)] overflow-hidden bg-white pt-[40px]">
        <div className="mx-auto h-full max-w-[1280px] px-4">
          <Outlet />
        </div>
      </main>
    </AuthGuard>
  );
}
